import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { customerActions } from "stores/customer/customerActions"
import { jarvisPrimeDashboardActions } from "stores/jarvisPrime/jarvisPrimeDashboard/jarvisPrimeDashboardActions";
import { jarvisPrimeOnboardingActions } from "stores/jarvisPrime/jarvisPrimeOnboarding/jarvisPrimeOnboardingActions";

const mapStateToProps = (state) => {
    return {
        profile: state.customer.profile,
        isOnboardingInitiallyFetched: state.jarvisPrime.primeDashboard.isInitialFetched,
        hasPortfolio: state.jarvisPrime.primeDashboard.portfolioPerformance.hasPortfolio || false,
        portfolioPerformance: state.jarvisPrime.primeDashboard.portfolioPerformance,
        
        
        isExpired: state.customer.profile.isExpired,
        isExpiring: state.customer.profile.isExpiring,
        isMobileVerified: state.customer.loginProfile.isMobileVerified,
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getOnboardingDataAction: jarvisPrimeOnboardingActions.getOnboardingData,
    getProfileAction: customerActions.getProfile,
    getPortfolioPerformanceAction: jarvisPrimeDashboardActions.getPortfolioPerformance,
}, dispatch)

const DashboardOnboardedStore = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);
export default DashboardOnboardedStore;